import { defineStore } from 'pinia';
import { IUnitModel } from '@/api/unit/unitModels';
/** Запросы к беку */
import apiUnitGetAll from '@/api/unit/getAll';
import apiUnitCreate from '@/api/unit/create';
import apiUnitUpdate from '@/api/unit/update';
import apiUnitDelete from '@/api/unit/delete';

export const useUnitStore = defineStore('units', {
    state: () => ({
        values: [] as IUnitModel[],
        isLoading: false,
        isLoaded: false,
    }),
    actions: {
        async getAllFromRemote() {
            try {
                if (this.isLoaded) return;
                this.isLoading = true;
                const response = await apiUnitGetAll();
                this.setState(response);
                this.isLoaded = true;
            } catch (error) {
                console.error('Error fetching units:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async create(unit: IUnitModel) {
            try {
                this.isLoading = true;
                await apiUnitCreate(unit);
                await this.getAllFromRemote();
            } catch (error) {
                console.error('Error creating units:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async update(unit: IUnitModel) {
            try {
                this.isLoading = true;
                const updated = await apiUnitUpdate(unit);
                if (updated) {
                    this.updateItem(updated);
                }
            } catch (error) {
                console.error('Error updating unit:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async delete(code: string) {
            try {
                this.isLoading = true;
                await apiUnitDelete(code);
                await this.getAllFromRemote();
            } catch (error) {
                console.error('Error deleting unit:', error);
            } finally {
                this.isLoading = false;
            }
        },
        setState(payload: IUnitModel[]) {
            this.values = payload;
        },
        updateItem(item: IUnitModel) {
            const index = this.values.findIndex(value => value.code === item.code);
            if (index !== -1) {
                this.values[index] = item;
            }
        },
        getOptionValue(code: string) {
            return this.unitsOptions.find(unit => unit.id === code)?.value || 'н/д';
        },
    },
    getters: {
        units: (state) => state.values,
        unitsOptions: (state) => state.values.map(unit => ({ id: unit.code, value: unit.title })),
    },
});